(() => {
  let dialog;
  let returnFocus;
  const init = (scope = document) => {
    scope.querySelectorAll('[data-mp-interaction]:not([data-mp-ready])').forEach(container => {
      container.dataset.mpReady = 'true';
      const video = container.querySelector('video');
      const button = container.querySelector('[data-mp-motion]');
      const reduced = matchMedia('(prefers-reduced-motion: reduce)');
      let userPaused = false;
      let visible = false;
      const load = () => {
        if (video.dataset.loaded) return;
        video.dataset.loaded = 'true';
        video.querySelectorAll('source[data-src]').forEach(source => { source.src = source.dataset.src; });
        video.muted = true;
        video.load();
      };
      const label = () => {
        button.querySelector('span').textContent = video.paused ? 'Play' : 'Pause';
        button.setAttribute('aria-label', `${video.paused ? 'Play' : 'Pause'} product interaction`);
      };
      const sync = () => {
        if (visible && !document.hidden && !reduced.matches && !userPaused) {
          load(); video.play().catch(label);
        } else { video.pause(); }
      };
      const observer = new IntersectionObserver(entries => {
        visible = entries[0].isIntersecting && entries[0].intersectionRatio >= 0.15;
        sync();
      }, {threshold:[0, 0.15]});
      observer.observe(video);
      button.addEventListener('click', () => {
        if (video.paused) { userPaused = false; load(); video.play().catch(label); }
        else { userPaused = true; video.pause(); }
      });
      video.addEventListener('play', label); video.addEventListener('pause', label);
      reduced.addEventListener('change', sync);
      document.addEventListener('visibilitychange', sync);
      const cleanup = event => {
        if (!event.target.contains(container)) return;
        observer.disconnect(); video.pause();
        reduced.removeEventListener('change', sync);
        document.removeEventListener('visibilitychange', sync);
        document.removeEventListener('shopify:section:unload', cleanup);
      };
      document.addEventListener('shopify:section:unload', cleanup);
    });
    scope.querySelectorAll('[data-mp-menu]:not([data-mp-ready])').forEach(menu => {
      menu.dataset.mpReady = 'true';
      const summary = menu.querySelector('summary');
      menu.addEventListener('toggle', () => summary.setAttribute('aria-expanded', String(menu.open)));
      menu.addEventListener('keydown', event => {
        if (event.key === 'Escape') { menu.open = false; summary.focus(); }
      });
      menu.addEventListener('click', event => { if (event.target.closest('a')) menu.open = false; });
      const breakpoint = matchMedia('(min-width: 1024px)');
      breakpoint.addEventListener('change', () => { if (breakpoint.matches) menu.open = false; });
    });
    scope.querySelectorAll('product-info.mp-product:not([data-mp-ready])').forEach(product => {
      product.dataset.mpReady = 'true';
      const mainButton = product.querySelector('.product-form__submit');
      const sticky = product.querySelector('[data-mp-sticky]');
      if (!mainButton || !sticky) return;
      const sync = () => {
        const price = product.querySelector('[id^="price-"]');
        const stickyPrice = sticky.querySelector('[data-mp-sticky-price]');
        const button = sticky.querySelector('button');
        stickyPrice.innerHTML = price.innerHTML;
        button.disabled = mainButton.disabled || mainButton.getAttribute('aria-disabled') === 'true';
        button.textContent = mainButton.querySelector('span')?.textContent.trim() || mainButton.textContent.trim();
        const quantity = product.querySelector('.quantity__input');
        sticky.querySelector('[data-mp-sticky-quantity]').textContent = `${product.querySelector('.quantity__label').textContent.trim()}: ${quantity.value}`;
      };
      const display = () => {
        const passed = mainButton.getBoundingClientRect().bottom < 0;
        const blocked = document.querySelector('dialog[open], [data-mp-menu][open], #shopify-pc__banner, .shopify-pc__prefs__dialog');
        const visible = passed && matchMedia('(max-width: 749px)').matches && !blocked;
        sticky.hidden = !visible;
        document.documentElement.style.setProperty('--mp-sticky-space', visible ? `${sticky.getBoundingClientRect().height + 16}px` : '0px');
      };
      const observer = new MutationObserver(sync);
      observer.observe(mainButton, {attributes:true, childList:true, subtree:true});
      observer.observe(product.querySelector('[id^="price-"]'), {childList:true, subtree:true, attributes:true});
      const intersection = new IntersectionObserver(display, {threshold:[0, 1]});
      intersection.observe(mainButton);
      product.addEventListener('change', sync);
      product.addEventListener('input', sync);
      window.addEventListener('scroll', display, {passive:true});
      window.addEventListener('resize', display, {passive:true});
      document.addEventListener('toggle', display, true);
      const cleanup = event => {
        if (!event.target.contains(product)) return;
        observer.disconnect(); intersection.disconnect();
        window.removeEventListener('scroll',display); window.removeEventListener('resize',display);
        document.removeEventListener('toggle',display,true); document.removeEventListener('shopify:section:unload',cleanup);
      };
      document.addEventListener('shopify:section:unload',cleanup);
      sync(); display();
    });
  };
  const openDialog = (content, trigger, label) => {
    if (!dialog) {
      dialog = document.createElement('dialog');
      dialog.className = 'mp-dialog mp-scope';
      dialog.innerHTML = '<button type="button" class="mp-dialog__close" aria-label="Close preview"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path d="m6 6 12 12M6 18 18 6"/></svg></button><div data-mp-dialog-content></div>';
      document.body.append(dialog);
      dialog.querySelector('button').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', e => { if (e.target === dialog) dialog.close(); });
      dialog.addEventListener('close', () => {
        dialog.querySelectorAll('video').forEach(video => { video.pause(); video.removeAttribute('src'); video.querySelectorAll('source').forEach(source => source.remove()); video.load(); });
        dialog.querySelector('[data-mp-dialog-content]').replaceChildren();
        returnFocus?.focus();
      });
    }
    returnFocus = trigger;
    dialog.classList.remove('mp-dialog--lesson');
    dialog.setAttribute('aria-label',label);
    dialog.querySelector('[data-mp-dialog-content]').replaceChildren(content);
    dialog.showModal();
    dialog.querySelector('button').focus();
  };
  document.addEventListener('click', event => {
    const detail = event.target.closest('[data-mp-detail-index]');
    if (detail) {
      const gallery = detail.closest('[data-mp-detail-gallery]');
      gallery.querySelectorAll('[data-mp-detail-slide]').forEach(slide => { slide.hidden = slide.dataset.mpDetailSlide !== detail.dataset.mpDetailIndex; });
      gallery.querySelectorAll('[data-mp-detail-index]').forEach(tab => tab.setAttribute('aria-pressed', String(tab === detail)));
    }
    const lesson = event.target.closest('[data-mp-lesson]');
    if (lesson) {
      const picture = lesson.querySelector('picture').cloneNode(true);
      picture.querySelector('img').loading = 'eager';
      openDialog(picture, lesson, 'Actual MoonPulse lesson webpage');
      dialog.classList.add('mp-dialog--lesson');
    }
    const play = event.target.closest('[data-mp-play], [data-mp-play-section]');
    if (play) {
      const source = play.closest('[data-mp-video]') || play.closest('.mp-demo-section')?.querySelector('[data-mp-video]');
      const template = source?.querySelector('template');
      if (!template) return;
      openDialog(template.content.cloneNode(true), play, play.getAttribute('aria-label') || play.textContent.trim());
      dialog.querySelector('video')?.play().catch(() => {});
    }
    const galleryTab = event.target.closest('[data-mp-gallery-index]');
    if (galleryTab) {
      const gallery = galleryTab.closest('[data-mp-gallery]');
      gallery.querySelectorAll('[data-mp-slide]').forEach(slide => { slide.hidden = slide.dataset.mpSlide !== galleryTab.dataset.mpGalleryIndex; });
      gallery.querySelectorAll('[data-mp-gallery-index]').forEach(tab => tab.setAttribute('aria-pressed', String(tab === galleryTab)));
    }
    const zoom = event.target.closest('[data-mp-zoom]');
    if (zoom) {
      const img = zoom.closest('[data-mp-slide]').querySelector('img');
      if (img) {
        const enlarged = img.cloneNode(true);
        enlarged.src = img.currentSrc; enlarged.removeAttribute('srcset'); enlarged.loading = 'eager';
        openDialog(enlarged,zoom,img.alt);
        if (img.closest('[data-asset-slot="K06"]')) dialog.classList.add('mp-dialog--lesson');
      }
    }
    const returnLink = event.target.closest('[data-mp-return]');
    if (returnLink) {
      const product = document.querySelector('product-info.mp-product');
      if (!product) return;
      event.preventDefault();
      const target = product.querySelector('variant-selects select, variant-selects input, .quantity__input, .product-form__submit');
      document.getElementById('mp-purchase').scrollIntoView({behavior:'auto',block:'start'});
      target?.focus({preventScroll:true});
    }
  });
  document.addEventListener('click', event => {
    document.querySelectorAll('[data-mp-menu][open]').forEach(menu => { if (!menu.contains(event.target)) menu.open=false; });
  });
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
